<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/contact-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Cambiar propietario del contacto</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona el nuevo propietario para este contacto</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeModal()" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <div class="mdl-body">
      <div class="mt-3">
        <label class="login-label" for="newOwner">Nuevo propietario:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div><img src="assets/svg/user-icon.svg" alt="icono usuario"></div>
            <div>
              <ng-select class="crm-ng-select"
                *ngIf="users && !isLoading"
                [items]="users"
                bindLabel="nombreCompleto"
                bindValue="usuario_id"
                placeholder="Buscar usuarios..."
                [(ngModel)]="selectedOwner"
                [searchable]="true"
                [clearable]="true">
                <ng-template ng-label-tmp let-item="item">
                  {{item.nombre}} {{item.apellido}}
                </ng-template>
              </ng-select>
              @if(isLoading) {
                <div class="loading-text">Cargando usuarios...</div>
              }
            </div>
          </div>
        </div>
        @if(errorMessage) {
          <div class="error-message">{{errorMessage}}</div>
        }
      </div>

      <div class="mt-3">
        <label class="crm-checkbox-label">
          <input type="checkbox" class="crm-checkbox" [(ngModel)]="sendNotification">
          <span class="crm-checkbox-custom"></span>
          Enviar notificación por correo electrónico al nuevo propietario
        </label>
      </div>

      <div class="mt-3" *ngIf="data.contacto">
        <b>El nuevo propietario </b>será también el propietario de estos registros relacionados con 
        <strong>{{ data.contacto.nombre }} {{ data.contacto.apellido }}</strong>,
        propiedad de <strong>{{ currentOwner }}</strong>:
        <ul>
          <li>Notas y archivos adjuntos</li>
          <li>Actividades abiertas</li>
        </ul>
      </div>

      <hr class="mt-4">

      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline" (click)="closeModal()">Cancelar</button>
        <button class="btn btn-primary" 
        (click)="saveChange()"
        [disabled]="isLoading || !selectedOwner || selectedOwner === data.contacto?.ejecutivo_id">
          @if(isLoading) {
            <span>Procesando...</span>
          } @else {
            <span>Cambiar Propietario</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>